import AlertCircle from './alert-circle.svg';
import AlertTriangle from './alert-triangle.svg';
import AlignVerticalCenter from './align-vertical-center.svg';
import AngelListBrand from './angel-list-brand.svg';
import AngelList from './angel-list.svg';
import AppleBrand from './apple-brand.svg';
import Apple from './apple.svg';
import ArbitrumBrand from './arbitrum-brand.svg';
import ArrowCircleBrokenDownLeft from './arrow-circle-broken-down-left.svg';
import ArrowCircleDownFilled from './arrow-circle-down-filled.svg';
import ArrowNarrow from './arrow-narrow.svg';
import Arrow from './arrow.svg';
import Asterisk from './asterisk.svg';
import BackupKit from './backup-kit.svg';
import Bank from './bank.svg';
import BaseBrand from './base-brand.svg';
import Brush from './brush.svg';
import CapsuleBlackBg from './capsule-black-bg.svg';
import CapsuleLogo from './capsule-logo.svg';
import CapsuleRingsDark from './capsule-rings-dark.svg';
import CapsuleRings from './capsule-rings.svg';
import Capsule from './capsule.svg';
import CeloBrand from './celo-brand.svg';
import CheckCircleFilled from './check-circle-filled.svg';
import CheckCircle from './check-circle.svg';
import CheckSquare from './check-square.svg';
import Check from './check.svg';
import ChevronDown from './chevron-down.svg';
import ChevronRight from './chevron-right.svg';
import ChevronSelectorVertical from './chevron-selector-vertical.svg';
import ChevronUp from './chevron-up.svg';
import Clock from './clock.svg';
import Close from './close.svg';
import ClubhouseBrand from './clubhouse-brand.svg';
import Clubhouse from './clubhouse.svg';
import Code from './code.svg';
import Copy07 from './copy-07.svg';
import Copy from './copy.svg';
import Cosmos from './cosmos.svg';
import CreditCard02 from './credit-card-02.svg';
import CreditCard from './credit-card.svg';
import Cube03 from './cube-03.svg';
import CubeOutline from './cube-outline.svg';
import Cube from './cube.svg';
import CurrencyDollar from './currency-dollar.svg';
import DecentBrand from './decent-brand.svg';
import Decent from './decent.svg';
import Dell from './dell.svg';
import DiscordBrand from './discord-brand.svg';
import Discord from './discord.svg';
import Dot from './dot.svg';
import Dots from './dots.svg';
import DownloadCloud from './download-cloud.svg';
import Download from './download.svg';
import DribbbleBrand from './dribbble-brand.svg';
import Dribbble from './dribbble.svg';
import Earth from './earth.svg';
import Edit02 from './edit-02.svg';
import EmptyCircle from './empty-circle.svg';
import Ethereum from './ethereum.svg';
import EyeOff from './eye-off.svg';
import Eye from './eye.svg';
import FacebookBrand from './facebook-brand.svg';
import Facebook from './facebook.svg';
import FarcasterBrand from './farcaster-brand.svg';
import Farcaster from './farcaster.svg';
import FigmaBrand from './figma-brand.svg';
import Figma from './figma.svg';
import File from './file.svg';
import Folder from './folder.svg';
import GithubBrand from './github-brand.svg';
import Github from './github.svg';
import Globe from './globe.svg';
import GoogleBrand from './google-brand.svg';
import Google from './google.svg';
import GridDots from './grid-dots.svg';
import HelpCircle from './help-circle.svg';
import HeroAlertCircle from './hero-alert-circle.svg';
import HeroCheckmarkCapsule from './hero-checkmark-capsule.svg';
import HeroCheckmark from './hero-checkmark.svg';
import HeroEmail from './hero-email.svg';
import HeroExternalConnection from './hero-external-connection.svg';
import HeroLock from './hero-lock.svg';
import HeroPasskey from './hero-passkey.svg';
import HeroPhone from './hero-phone.svg';
import HeroPlusCircleCapsule from './hero-plus-circle-capsule.svg';
import HeroPlusCircle from './hero-plus-circle.svg';
import HeroWallet from './hero-wallet.svg';
import Home from './home.svg';
import Hp from './hp.svg';
import Image from './image.svg';
import InfoCircle from './info-circle.svg';
import InstagramBrand from './instagram-brand.svg';
import Instagram from './instagram.svg';
import Key from './key.svg';
import Laptop from './laptop.svg';
import Lenovo from './lenovo.svg';
import Lg from './lg.svg';
import Lightning01 from './lightning-01.svg';
import Lightning from './lightning.svg';
import LinkExternal from './link-external.svg';
import LinkedinBrand from './linkedin-brand.svg';
import Linkedin from './linkedin.svg';
import LockKeyholeCircle from './lock-keyhole-circle.svg';
import LogOut from './log-out.svg';
import Mail from './mail.svg';
import Menu from './menu.svg';
import Monitor from './monitor.svg';
import MoonpayBrand from './moonpay-brand.svg';
import MoreLoginOptions from './more-login-options.svg';
import Motorola from './motorola.svg';
import NobleBrand from './noble-brand.svg';
import OptimismBrand from './optimism-brand.svg';
import Passcode from './passcode.svg';
import Phone from './phone.svg';
import PintrestBrand from './pintrest-brand.svg';
import Pintrest from './pintrest.svg';
import PlusCircle from './plus-circle.svg';
import Plus from './plus.svg';
import PolygonBrand from './polygon-brand.svg';
import Polygon from './polygon.svg';
import PuzzlePiece from './puzzle-piece.svg';
import QrCode02 from './qr-code-02.svg';
import QrCode from './qr-code.svg';
import RampNetworkBrand from './ramp-network-brand.svg';
import RampNetwork from './ramp-network.svg';
import RedditBrand from './reddit-brand.svg';
import Reddit from './reddit.svg';
import Refresh from './refresh.svg';
import Samsung from './samsung.svg';
import Search from './search.svg';
import Send from './send.svg';
import Settings from './settings.svg';
import Share from './share.svg';
import Shield from './shield.svg';
import SignalBrand from './signal-brand.svg';
import Signal from './signal.svg';
import Sliders from './sliders.svg';
import SnapchatBrand from './snapchat-brand.svg';
import Snapchat from './snapchat.svg';
import Solana from './solana.svg';
import SpacingHeight from './spacing-height.svg';
import Star04Filled from './star-04-filled.svg';
import Stars01Filled from './stars-01-filled.svg';
import Stars from './stars.svg';
import StopSquare from './stop-square.svg';
import StripeBrand from './stripe-brand.svg';
import TelegramBrand from './telegram-brand.svg';
import Telegram from './telegram.svg';
import TetherBrand from './tether-brand.svg';
import TikTokBrand from './tik-tok-brand.svg';
import TikTok from './tik-tok.svg';
import Trash from './trash.svg';
import TumblrBrand from './tumblr-brand.svg';
import Tumblr from './tumblr.svg';
import TwitterBrand from './twitter-brand.svg';
import Twitter from './twitter.svg';
import UsdcBrand from './usdc-brand.svg';
import UserCircle from './user-circle.svg';
import User from './user.svg';
import Wallet from './wallet.svg';
import X from './x.svg';
import YoutubeBrand from './youtube-brand.svg';
import Youtube from './youtube.svg';
import AD from './flags/AD.svg';
import AE from './flags/AE.svg';
import AF from './flags/AF.svg';
import AG from './flags/AG.svg';
import AI from './flags/AI.svg';
import AL from './flags/AL.svg';
import AM from './flags/AM.svg';
import AO from './flags/AO.svg';
import AR from './flags/AR.svg';
import AS from './flags/AS.svg';
import AT from './flags/AT.svg';
import AU from './flags/AU.svg';
import AW from './flags/AW.svg';
import AX from './flags/AX.svg';
import AZ from './flags/AZ.svg';
import BA from './flags/BA.svg';
import BB from './flags/BB.svg';
import BD from './flags/BD.svg';
import BE from './flags/BE.svg';
import BF from './flags/BF.svg';
import BG from './flags/BG.svg';
import BH from './flags/BH.svg';
import BI from './flags/BI.svg';
import BJ from './flags/BJ.svg';
import BL from './flags/BL.svg';
import BM from './flags/BM.svg';
import BN from './flags/BN.svg';
import BO from './flags/BO.svg';
import BQ from './flags/BQ.svg';
import BQ2 from './flags/BQ2.svg';
import BQ3 from './flags/BQ3.svg';
import BR from './flags/BR.svg';
import BS from './flags/BS.svg';
import BT from './flags/BT.svg';
import BW from './flags/BW.svg';
import BY from './flags/BY.svg';
import BZ from './flags/BZ.svg';
import CA from './flags/CA.svg';
import CC from './flags/CC.svg';
import CD from './flags/CD.svg';
import CD2 from './flags/CD2.svg';
import CF from './flags/CF.svg';
import CH from './flags/CH.svg';
import CK from './flags/CK.svg';
import CL from './flags/CL.svg';
import CM from './flags/CM.svg';
import CN from './flags/CN.svg';
import CO from './flags/CO.svg';
import CR from './flags/CR.svg';
import CU from './flags/CU.svg';
import CW from './flags/CW.svg';
import CX from './flags/CX.svg';
import CY from './flags/CY.svg';
import CZ from './flags/CZ.svg';
import DE from './flags/DE.svg';
import DJ from './flags/DJ.svg';
import DK from './flags/DK.svg';
import DM from './flags/DM.svg';
import DO from './flags/DO.svg';
import DS from './flags/DS.svg';
import DZ from './flags/DZ.svg';
import EC from './flags/EC.svg';
import EE from './flags/EE.svg';
import EG from './flags/EG.svg';
import EH from './flags/EH.svg';
import ER from './flags/ER.svg';
import ES from './flags/ES.svg';
import ET from './flags/ET.svg';
import FI from './flags/FI.svg';
import FJ from './flags/FJ.svg';
import FK from './flags/FK.svg';
import FM from './flags/FM.svg';
import FO from './flags/FO.svg';
import FR from './flags/FR.svg';
import GA from './flags/GA.svg';
import GB2 from './flags/GB-2.svg';
import GB from './flags/GB.svg';
import GD from './flags/GD.svg';
import GE from './flags/GE.svg';
import GG from './flags/GG.svg';
import GH from './flags/GH.svg';
import GI from './flags/GI.svg';
import GL from './flags/GL.svg';
import GM from './flags/GM.svg';
import GN from './flags/GN.svg';
import GQ from './flags/GQ.svg';
import GR from './flags/GR.svg';
import GT from './flags/GT.svg';
import GU from './flags/GU.svg';
import GW from './flags/GW.svg';
import GY from './flags/GY.svg';
import HK from './flags/HK.svg';
import HN from './flags/HN.svg';
import HR from './flags/HR.svg';
import HT from './flags/HT.svg';
import HU from './flags/HU.svg';
import ID from './flags/ID.svg';
import IE from './flags/IE.svg';
import IL from './flags/IL.svg';
import IM from './flags/IM.svg';
import IN from './flags/IN.svg';
import IO from './flags/IO.svg';
import IQ from './flags/IQ.svg';
import IR from './flags/IR.svg';
import IS from './flags/IS.svg';
import IT from './flags/IT.svg';
import JE from './flags/JE.svg';
import JM from './flags/JM.svg';
import JO from './flags/JO.svg';
import JP from './flags/JP.svg';
import KE from './flags/KE.svg';
import KG from './flags/KG.svg';
import KH from './flags/KH.svg';
import KI from './flags/KI.svg';
import KM from './flags/KM.svg';
import KN from './flags/KN.svg';
import KP from './flags/KP.svg';
import KR from './flags/KR.svg';
import KW from './flags/KW.svg';
import KY from './flags/KY.svg';
import KZ from './flags/KZ.svg';
import LA from './flags/LA.svg';
import LB from './flags/LB.svg';
import LC from './flags/LC.svg';
import LI from './flags/LI.svg';
import LK from './flags/LK.svg';
import LR from './flags/LR.svg';
import LS from './flags/LS.svg';
import LT from './flags/LT.svg';
import LU from './flags/LU.svg';
import LV from './flags/LV.svg';
import LY from './flags/LY.svg';
import MA from './flags/MA.svg';
import MC from './flags/MC.svg';
import MD from './flags/MD.svg';
import ME from './flags/ME.svg';
import MG from './flags/MG.svg';
import MH from './flags/MH.svg';
import MK from './flags/MK.svg';
import ML from './flags/ML.svg';
import MM from './flags/MM.svg';
import MN from './flags/MN.svg';
import MO from './flags/MO.svg';
import MP from './flags/MP.svg';
import MQ from './flags/MQ.svg';
import MR from './flags/MR.svg';
import MS from './flags/MS.svg';
import MT from './flags/MT.svg';
import MU from './flags/MU.svg';
import MV from './flags/MV.svg';
import MW from './flags/MW.svg';
import MX from './flags/MX.svg';
import MY from './flags/MY.svg';
import MZ from './flags/MZ.svg';
import NA from './flags/NA.svg';
import NE from './flags/NE.svg';
import NF from './flags/NF.svg';
import NG from './flags/NG.svg';
import NI from './flags/NI.svg';
import NL from './flags/NL.svg';
import NO from './flags/NO.svg';
import NP from './flags/NP.svg';
import NR from './flags/NR.svg';
import NU from './flags/NU.svg';
import NZ from './flags/NZ.svg';
import OM from './flags/OM.svg';
import PA from './flags/PA.svg';
import PE from './flags/PE.svg';
import PF from './flags/PF.svg';
import PG from './flags/PG.svg';
import PH from './flags/PH.svg';
import PK from './flags/PK.svg';
import PL from './flags/PL.svg';
import PN from './flags/PN.svg';
import PR from './flags/PR.svg';
import PS from './flags/PS.svg';
import PT from './flags/PT.svg';
import PW from './flags/PW.svg';
import PY from './flags/PY.svg';
import QA from './flags/QA.svg';
import RO from './flags/RO.svg';
import RS from './flags/RS.svg';
import RU from './flags/RU.svg';
import RW from './flags/RW.svg';
import SA from './flags/SA.svg';
import SB from './flags/SB.svg';
import SC from './flags/SC.svg';
import SE from './flags/SE.svg';
import SG from './flags/SG.svg';
import SI from './flags/SI.svg';
import SK from './flags/SK.svg';
import SL from './flags/SL.svg';
import SM from './flags/SM.svg';
import SN from './flags/SN.svg';
import SO from './flags/SO.svg';
import SR from './flags/SR.svg';
import SS from './flags/SS.svg';
import ST from './flags/ST.svg';
import SV from './flags/SV.svg';
import SX from './flags/SX.svg';
import SY from './flags/SY.svg';
import SZ from './flags/SZ.svg';
import TC from './flags/TC.svg';
import TD from './flags/TD.svg';
import TG from './flags/TG.svg';
import TH from './flags/TH.svg';
import TJ from './flags/TJ.svg';
import TK from './flags/TK.svg';
import TL from './flags/TL.svg';
import TM from './flags/TM.svg';
import TN from './flags/TN.svg';
import TO from './flags/TO.svg';
import TR from './flags/TR.svg';
import TT from './flags/TT.svg';
import TV from './flags/TV.svg';
import TW from './flags/TW.svg';
import TZ from './flags/TZ.svg';
import UA from './flags/UA.svg';
import UG from './flags/UG.svg';
import US from './flags/US.svg';
import UY from './flags/UY.svg';
import UZ from './flags/UZ.svg';
import VC from './flags/VC.svg';
import VE from './flags/VE.svg';
import VG from './flags/VG.svg';
import VI from './flags/VI.svg';
import VN from './flags/VN.svg';
import VU from './flags/VU.svg';
import WS from './flags/WS.svg';
import YE from './flags/YE.svg';
import ZA from './flags/ZA.svg';
import ZM from './flags/ZM.svg';
import ZW from './flags/ZW.svg';

export const Icons = {
  alertCircle: AlertCircle,
  alertTriangle: AlertTriangle,
  alignVerticalCenter: AlignVerticalCenter,
  angelListBrand: AngelListBrand,
  angelList: AngelList,
  appleBrand: AppleBrand,
  apple: Apple,
  arbitrumBrand: ArbitrumBrand,
  arrowCircleBrokenDownLeft: ArrowCircleBrokenDownLeft,
  arrowCircleDownFilled: ArrowCircleDownFilled,
  arrowNarrow: ArrowNarrow,
  arrow: Arrow,
  asterisk: Asterisk,
  backupKit: BackupKit,
  bank: Bank,
  baseBrand: BaseBrand,
  brush: Brush,
  capsuleBlackBg: CapsuleBlackBg,
  capsuleLogo: CapsuleLogo,
  capsuleRingsDark: CapsuleRingsDark,
  capsuleRings: CapsuleRings,
  capsule: Capsule,
  celoBrand: CeloBrand,
  checkCircleFilled: CheckCircleFilled,
  checkCircle: CheckCircle,
  checkSquare: CheckSquare,
  check: Check,
  chevronDown: ChevronDown,
  chevronRight: ChevronRight,
  chevronSelectorVertical: ChevronSelectorVertical,
  chevronUp: ChevronUp,
  clock: Clock,
  close: Close,
  clubhouseBrand: ClubhouseBrand,
  clubhouse: Clubhouse,
  code: Code,
  copy07: Copy07,
  copy: Copy,
  cosmos: Cosmos,
  creditCard02: CreditCard02,
  creditCard: CreditCard,
  cube03: Cube03,
  cubeOutline: CubeOutline,
  cube: Cube,
  currencyDollar: CurrencyDollar,
  decentBrand: DecentBrand,
  decent: Decent,
  dell: Dell,
  discordBrand: DiscordBrand,
  discord: Discord,
  dot: Dot,
  dots: Dots,
  downloadCloud: DownloadCloud,
  download: Download,
  dribbbleBrand: DribbbleBrand,
  dribbble: Dribbble,
  earth: Earth,
  edit02: Edit02,
  emptyCircle: EmptyCircle,
  ethereum: Ethereum,
  eyeOff: EyeOff,
  eye: Eye,
  facebookBrand: FacebookBrand,
  facebook: Facebook,
  farcasterBrand: FarcasterBrand,
  farcaster: Farcaster,
  figmaBrand: FigmaBrand,
  figma: Figma,
  file: File,
  folder: Folder,
  githubBrand: GithubBrand,
  github: Github,
  globe: Globe,
  googleBrand: GoogleBrand,
  google: Google,
  gridDots: GridDots,
  helpCircle: HelpCircle,
  heroAlertCircle: HeroAlertCircle,
  heroCheckmarkCapsule: HeroCheckmarkCapsule,
  heroCheckmark: HeroCheckmark,
  heroEmail: HeroEmail,
  heroExternalConnection: HeroExternalConnection,
  heroLock: HeroLock,
  heroPasskey: HeroPasskey,
  heroPhone: HeroPhone,
  heroPlusCircleCapsule: HeroPlusCircleCapsule,
  heroPlusCircle: HeroPlusCircle,
  heroWallet: HeroWallet,
  home: Home,
  hp: Hp,
  image: Image,
  infoCircle: InfoCircle,
  instagramBrand: InstagramBrand,
  instagram: Instagram,
  key: Key,
  laptop: Laptop,
  lenovo: Lenovo,
  lg: Lg,
  lightning01: Lightning01,
  lightning: Lightning,
  linkExternal: LinkExternal,
  linkedinBrand: LinkedinBrand,
  linkedin: Linkedin,
  lockKeyholeCircle: LockKeyholeCircle,
  logOut: LogOut,
  mail: Mail,
  menu: Menu,
  monitor: Monitor,
  moonpayBrand: MoonpayBrand,
  moreLoginOptions: MoreLoginOptions,
  motorola: Motorola,
  nobleBrand: NobleBrand,
  optimismBrand: OptimismBrand,
  passcode: Passcode,
  phone: Phone,
  pintrestBrand: PintrestBrand,
  pintrest: Pintrest,
  plusCircle: PlusCircle,
  plus: Plus,
  polygonBrand: PolygonBrand,
  polygon: Polygon,
  puzzlePiece: PuzzlePiece,
  qrCode02: QrCode02,
  qrCode: QrCode,
  rampNetworkBrand: RampNetworkBrand,
  rampNetwork: RampNetwork,
  redditBrand: RedditBrand,
  reddit: Reddit,
  refresh: Refresh,
  samsung: Samsung,
  search: Search,
  send: Send,
  settings: Settings,
  share: Share,
  shield: Shield,
  signalBrand: SignalBrand,
  signal: Signal,
  sliders: Sliders,
  snapchatBrand: SnapchatBrand,
  snapchat: Snapchat,
  solana: Solana,
  spacingHeight: SpacingHeight,
  star04Filled: Star04Filled,
  stars01Filled: Stars01Filled,
  stars: Stars,
  stopSquare: StopSquare,
  stripeBrand: StripeBrand,
  telegramBrand: TelegramBrand,
  telegram: Telegram,
  tetherBrand: TetherBrand,
  tikTokBrand: TikTokBrand,
  tikTok: TikTok,
  trash: Trash,
  tumblrBrand: TumblrBrand,
  tumblr: Tumblr,
  twitterBrand: TwitterBrand,
  twitter: Twitter,
  usdcBrand: UsdcBrand,
  userCircle: UserCircle,
  user: User,
  wallet: Wallet,
  x: X,
  youtubeBrand: YoutubeBrand,
  youtube: Youtube,
  AD: AD,
  AE: AE,
  AF: AF,
  AG: AG,
  AI: AI,
  AL: AL,
  AM: AM,
  AO: AO,
  AR: AR,
  AS: AS,
  AT: AT,
  AU: AU,
  AW: AW,
  AX: AX,
  AZ: AZ,
  BA: BA,
  BB: BB,
  BD: BD,
  BE: BE,
  BF: BF,
  BG: BG,
  BH: BH,
  BI: BI,
  BJ: BJ,
  BL: BL,
  BM: BM,
  BN: BN,
  BO: BO,
  BQ: BQ,
  BQ2: BQ2,
  BQ3: BQ3,
  BR: BR,
  BS: BS,
  BT: BT,
  BW: BW,
  BY: BY,
  BZ: BZ,
  CA: CA,
  CC: CC,
  CD: CD,
  CD2: CD2,
  CF: CF,
  CH: CH,
  CK: CK,
  CL: CL,
  CM: CM,
  CN: CN,
  CO: CO,
  CR: CR,
  CU: CU,
  CW: CW,
  CX: CX,
  CY: CY,
  CZ: CZ,
  DE: DE,
  DJ: DJ,
  DK: DK,
  DM: DM,
  DO: DO,
  DS: DS,
  DZ: DZ,
  EC: EC,
  EE: EE,
  EG: EG,
  EH: EH,
  ER: ER,
  ES: ES,
  ET: ET,
  FI: FI,
  FJ: FJ,
  FK: FK,
  FM: FM,
  FO: FO,
  FR: FR,
  GA: GA,
  GB2: GB2,
  GB: GB,
  GD: GD,
  GE: GE,
  GG: GG,
  GH: GH,
  GI: GI,
  GL: GL,
  GM: GM,
  GN: GN,
  GQ: GQ,
  GR: GR,
  GT: GT,
  GU: GU,
  GW: GW,
  GY: GY,
  HK: HK,
  HN: HN,
  HR: HR,
  HT: HT,
  HU: HU,
  ID: ID,
  IE: IE,
  IL: IL,
  IM: IM,
  IN: IN,
  IO: IO,
  IQ: IQ,
  IR: IR,
  IS: IS,
  IT: IT,
  JE: JE,
  JM: JM,
  JO: JO,
  JP: JP,
  KE: KE,
  KG: KG,
  KH: KH,
  KI: KI,
  KM: KM,
  KN: KN,
  KP: KP,
  KR: KR,
  KW: KW,
  KY: KY,
  KZ: KZ,
  LA: LA,
  LB: LB,
  LC: LC,
  LI: LI,
  LK: LK,
  LR: LR,
  LS: LS,
  LT: LT,
  LU: LU,
  LV: LV,
  LY: LY,
  MA: MA,
  MC: MC,
  MD: MD,
  ME: ME,
  MG: MG,
  MH: MH,
  MK: MK,
  ML: ML,
  MM: MM,
  MN: MN,
  MO: MO,
  MP: MP,
  MQ: MQ,
  MR: MR,
  MS: MS,
  MT: MT,
  MU: MU,
  MV: MV,
  MW: MW,
  MX: MX,
  MY: MY,
  MZ: MZ,
  NA: NA,
  NE: NE,
  NF: NF,
  NG: NG,
  NI: NI,
  NL: NL,
  NO: NO,
  NP: NP,
  NR: NR,
  NU: NU,
  NZ: NZ,
  OM: OM,
  PA: PA,
  PE: PE,
  PF: PF,
  PG: PG,
  PH: PH,
  PK: PK,
  PL: PL,
  PN: PN,
  PR: PR,
  PS: PS,
  PT: PT,
  PW: PW,
  PY: PY,
  QA: QA,
  RO: RO,
  RS: RS,
  RU: RU,
  RW: RW,
  SA: SA,
  SB: SB,
  SC: SC,
  SE: SE,
  SG: SG,
  SI: SI,
  SK: SK,
  SL: SL,
  SM: SM,
  SN: SN,
  SO: SO,
  SR: SR,
  SS: SS,
  ST: ST,
  SV: SV,
  SX: SX,
  SY: SY,
  SZ: SZ,
  TC: TC,
  TD: TD,
  TG: TG,
  TH: TH,
  TJ: TJ,
  TK: TK,
  TL: TL,
  TM: TM,
  TN: TN,
  TO: TO,
  TR: TR,
  TT: TT,
  TV: TV,
  TW: TW,
  TZ: TZ,
  UA: UA,
  UG: UG,
  US: US,
  UY: UY,
  UZ: UZ,
  VC: VC,
  VE: VE,
  VG: VG,
  VI: VI,
  VN: VN,
  VU: VU,
  WS: WS,
  YE: YE,
  ZA: ZA,
  ZM: ZM,
  ZW: ZW,
};
